// extracted by mini-css-extract-plugin
export default {"card":"k_-z","carousel":"l_-z"};